import React, { useState, useEffect } from "react";
import "./App.css";
import Products from "./Products";
import {
  Box,
  Container,
  Grid,
  Typography,
  Drawer,
  IconButton,
} from "@mui/material";
import Filters from "./Filters";
import TuneIcon from "@mui/icons-material/Tune";
function Home({ selectedCategory, setSelectedCategory = () => {} }) {
  const [selectedFilters, setSelectedFilters] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };

    handleResize(); // Set initial isMobile state
    window.addEventListener("resize", handleResize); // Listen for resize events

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const handleFiltersChange = (filters) => {
    setSelectedFilters(filters);
  };

  const clearFilters = () => {
    setSelectedFilters({});
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      <Container maxWidth="md">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={!isMobile ? 3 : 12} md={!isMobile ? 3 : 12}>
            {isMobile && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography>Filters</Typography>
                  <IconButton onClick={toggleDrawer}>
                    <TuneIcon />
                  </IconButton>
                </Box>
                <Drawer
                  sx={{
                    py: 4,
                  }}
                  variant="temporary"
                  anchor="left"
                  open={drawerOpen}
                  onClose={toggleDrawer}
                >
                  <Filters
                    selectedCategory={selectedCategory}
                    onFiltersChange={handleFiltersChange}
                    clearFilters={clearFilters}
                  />
                </Drawer>
              </>
            )}
            {!isMobile && (
              <Filters
                selectedCategory={selectedCategory}
                onFiltersChange={handleFiltersChange}
                clearFilters={clearFilters}
              />
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={!isMobile ? 9 : 12}
            md={!isMobile ? 9 : 12}
            sx={{ mt: 5 }}
          >
            <Products
              selectedCategory={selectedCategory}
              selectedFilters={selectedFilters}
              clearFilters={clearFilters}
              setSelectedCategory={setSelectedCategory}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Home;
